import keepRouteCurrent from './keepRouteCurrent';
import navigateToRoute from './navigateToRoute';
import RouterOptions from './RouterOptions';
import router from './routerInstance';
import registerRoute from './registerRoute';

export default async function initializeRouter(
    routerOptions: RouterOptions | undefined,
    registerRoutes?:
        | ((registerRouteFunction: typeof registerRoute, registerAll?: boolean) => Promise<void>)
        | undefined,
    registerAll?: boolean
) {
    if (registerRoutes) {
        await registerRoutes(registerRoute, registerAll);
    }

    if (routerOptions) {
        router.configure({
            notfound: () => {
                routerOptions.routeGenerator.then(generator => {
                    navigateToRoute(generator());
                });
            },
            html5history: true,
            convert_hash_in_init: false,
            run_handler_in_init: true,
            strict: false,
            async: true,
        });

        router.init();

        if (!routerOptions.staticUrl) {
            routerOptions.routeGenerator.then(generator => {
                keepRouteCurrent(generator);
            });
        }
    }
}
